import { Component, signal } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { UserMenuComponent } from '../features/account/user-menu.component';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [UserMenuComponent, RouterModule, CommonModule, RouterOutlet, MatIconModule, MatDividerModule]
})

export class LayoutComponent {
  isLoggedIn = signal<boolean>(false);
  url = signal<string>('');
  isMobileMenuOpen = signal<boolean>(false);
  
  constructor(private authService: AuthService, private router: Router) {
    this.authService.user$.subscribe(user => {
      this.isLoggedIn.set(!!user);
    });
    this.router.events.subscribe((event: any)  => {
      if (event instanceof NavigationEnd) {
        this.url.set(event.url);
        console.log(this.url());
        // Close mobile menu when navigating
        this.isMobileMenuOpen.set(false);
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  toggleMenu() {
    this.isMobileMenuOpen.update(current => !current);
  }
  
}
